import { createSlice } from '@reduxjs/toolkit'
import { TalkChannelFontColors } from '../../../Codes'
import { isValidUrl } from '../../../../utils'

export const initialThumbnailCustomState = {
  dominantColors: [],
  thumbnail: undefined,
  backgroundColor: undefined,
  proposalPhraseTop: '',
  proposalPhraseBottom: '',
  actionInduction: '',
  fontColor: TalkChannelFontColors.BLACK,
  fontColorLegal: TalkChannelFontColors.BLACK,
  landingUrl: '',
}
const thumbnailCustomSlice = createSlice({
  name: 'thumbnailCustom',
  initialState: initialThumbnailCustomState,
  reducers: {
    reset: () => initialThumbnailCustomState,
    setDominantColors: (state, { payload: dominantColors }) => {
      state.dominantColors = dominantColors
    },
    setThumbnail: (
      state,
      { payload: { id, url, name, size, width, height } }
    ) => {
      state.thumbnail = {
        id,
        url,
        name,
        size,
        width,
        height,
      }
    },
    setThumbnailCustomId: (state, { payload: { dspImageDtos } }) => {
      const image = dspImageDtos.find(
        ({ url }) => state?.thumbnail?.url === url
      )
      if (image) {
        state.thumbnail.id = image.id
      }
    },
    clearThumbnail: state => {
      state.thumbnail = undefined
      state.dominantColors = []
      state.backgroundColor = undefined
      state.fontColor = TalkChannelFontColors.BLACK
      state.fontColorLegal = TalkChannelFontColors.BLACK
    },
    setBackgroundColor: (state, { payload: backgroundColor }) => {
      state.backgroundColor = backgroundColor
    },
    setProposalPhraseTop: (state, { payload: proposalPhraseTop }) => {
      state.proposalPhraseTop = proposalPhraseTop
    },
    setProposalPhraseBottom: (state, { payload: proposalPhraseBottom }) => {
      state.proposalPhraseBottom = proposalPhraseBottom
    },
    setActionInduction: (state, { payload: actionInduction }) => {
      state.actionInduction = actionInduction
    },
    setFontColor: (state, { payload: fontColor }) => {
      state.fontColor = fontColor
    },
    setFontColorLegal: (state, { payload: fontColorLegal }) => {
      state.fontColorLegal = fontColorLegal
    },
    setLandingUrl: (state, { payload: landingUrl }) => {
      state.landingUrl = landingUrl
    },
    importThumbnailCustom: (state, { payload: thumbnailCustom }) =>
      thumbnailCustom,
  },
})
export const {
  reset,
  setDominantColors,
  setThumbnail,
  setThumbnailCustomId,
  clearThumbnail,
  setBackgroundColor,
  setProposalPhraseTop,
  setProposalPhraseBottom,
  setActionInduction,
  setFontColor,
  setFontColorLegal,
  setLandingUrl,
  importThumbnailCustom,
} = thumbnailCustomSlice.actions

export default thumbnailCustomSlice.reducer

export const validateThumbnailCustom = ({
  thumbnail,
  backgroundColor,
  proposalPhraseTop,
  proposalPhraseBottom,
  actionInduction,
  landingUrl,
}) => ({
  thumbnail: thumbnail === undefined && '썸네일 이미지를 등록하세요.',
  backgroundColor: backgroundColor === undefined && '배경 색상을 선택하세요.',
  proposalPhraseTop:
    proposalPhraseTop.trim() === '' && '상단 홍보문구를 입력하세요.',
  proposalPhraseBottom:
    proposalPhraseBottom.trim() === '' && '하단 홍보문구를 입력하세요.',
  actionInduction:
    actionInduction.trim() === '' && '행동유도버튼 문구를 입력하세요.',
  landingUrl:
    landingUrl.trim() === ''
      ? '랜딩 URL을 입력하세요.'
      : !isValidUrl(landingUrl) && '유효한 랜딩 URL을 입력하세요.',
})

export const getThumbnailCustomAssetData = state => ({
  type: 'THUMBNAIL_CUSTOM',
  assets: [
    {
      type: 'THUMBNAIL_CUSTOM',
      data: {
        image: {
          id: state.thumbnail.id,
          url: state.thumbnail.url,
          w: state.thumbnail.width,
          h: state.thumbnail.height,
          name: state.thumbnail.name,
          size: state.thumbnail.size,
        },
      },
    },
    {
      type: 'BACKGROUND_COLOR',
      data: { color: state.backgroundColor },
    },
    {
      type: 'FONT_COLOR',
      data: { color: state.fontColor },
    },
    {
      type: 'PROPOSAL_PHRASE_TOP',
      data: { text: state.proposalPhraseTop },
    },
    {
      type: 'PROPOSAL_PHRASE_BOTTOM',
      data: { text: state.proposalPhraseBottom },
    },
    {
      type: 'ACTION_INDUCTION',
      data: { text: state.actionInduction },
    },
    {
      type: 'LANDING_URL',
      data: { url: state.landingUrl },
    },
    {
      type: 'FONT_COLOR_LEGAL',
      data: { color: state.fontColorLegal },
    },
  ],
})
